import(/* webpackMode: "eager" */ "/codebuild/output/src634977028/src/boj-random-defense-client/node_modules/next/dist/client/link.js");
;
import(/* webpackMode: "eager" */ "/codebuild/output/src634977028/src/boj-random-defense-client/node_modules/next/dist/shared/lib/lazy-dynamic/dynamic-bailout-to-csr.js");
;
import(/* webpackMode: "eager" */ "/codebuild/output/src634977028/src/boj-random-defense-client/node_modules/next/dist/shared/lib/lazy-dynamic/preload-css.js");
;
import(/* webpackMode: "eager" */ "/codebuild/output/src634977028/src/boj-random-defense-client/src/app/ui/rating.module.css");
;
import(/* webpackMode: "eager" */ "/codebuild/output/src634977028/src/boj-random-defense-client/src/app/user/[handle]/detail.tsx");
;
import(/* webpackMode: "eager" */ "/codebuild/output/src634977028/src/boj-random-defense-client/src/app/user/[handle]/page.module.css");
